export interface TabRouteDestination {
  id: string;
  routeKey: App.Global.Tab['routeKey'];
  routePath: App.Global.Tab['routePath'];
  fullPath: string;
  fixedIndex?: number;
  icon?: string;
  localIcon?: string;
  i18nKey?: App.I18n.I18nKey;
}

/**
 * Refresh the route destination of an existing tab without discarding a
 * caller-customized label. Query-driven soft views share a path-based tab id,
 * so their latest fullPath must replace the stale destination stored earlier.
 */
export function updateTabRouteDestination(currentTab: App.Global.Tab, nextTab: TabRouteDestination): App.Global.Tab {
  if (currentTab.id !== nextTab.id) return currentTab;

  return {
    ...currentTab,
    routeKey: nextTab.routeKey,
    routePath: nextTab.routePath,
    fullPath: nextTab.fullPath,
    fixedIndex: nextTab.fixedIndex,
    icon: nextTab.icon,
    localIcon: nextTab.localIcon,
    i18nKey: nextTab.i18nKey
  };
}
